import { h } from "./../../../utils/createElement";
import { __assign, __spreadArrays } from "tslib";
import * as React from 'react';
import classnames from 'classnames';
import MultiPickerMixin from './MultiPickerMixin';
var MultiPicker = function (props) {
    var prefixCls = props.prefixCls, className = props.className, rootNativeProps = props.rootNativeProps, children = props.children, style = props.style;
    var selectedValue = props.getValue();
    var colElements = React.Children.map(children, function (col, i) {
        return React.cloneElement(col, {
            selectedValue: selectedValue[i],
            onValueChange: function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                return props.onValueChange.apply(props, __spreadArrays([i], args));
            },
            onScrollChange: props.onScrollChange && (function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                return props.onScrollChange.apply(props, __spreadArrays([i], args));
            }),
        });
    });
    return (h("div", __assign({}, rootNativeProps, { style: style, className: classnames(className, prefixCls) }), colElements));
};
export default MultiPickerMixin(MultiPicker);
